<main class="esf-main-content esf-main-content--has-sidebar -has-transition -width-max" [class.-is-open]="sidebarService.isOpened">
  <div class="esf-container main-content">

    <h1 class="esf-heading esf-heading--page">
      <span class="esf-action-heading__text" i18n='@@importDataComponent.heading.importData'>Import data</span>
    </h1>
    <p i18n='@@importDataComponent.description.heading'>Import customer information within five steps</p>

    <ol>
      <li i18n='@@importDataComponent.description.step1'>Select what to upload</li>
      <li i18n='@@importDataComponent.description.step2'>Download template file</li>
      <li i18n='@@importDataComponent.description.step3'>Populate template file and consider provided comments</li>
      <li i18n='@@importDataComponent.description.step4'>Upload file as csv and start the import</li>
      <li i18n='@@importDataComponent.description.step5'>The import will run in the background and finish within a few minutes</li>
    </ol>

    <div class="esf-form-item">
      <div class="esf-select">
        <select class="esf-form-item__field esf-select__field" (change)="setSelectedDataType($event)">
          <option i18n="Select option@@general.selectOption.selectDataType" [value]="null">Select data type</option>
          <option i18n="Select option@@general.selectOption.attributes" [value]="'club-attributes'">Attributes</option>
          <option i18n="Select option@@general.selectOption.membership" [value]="'membership'">Membership</option>
        </select>
      </div>
    </div>

    <div class="esf-submit-row">
      <div class="esf-submit-row__item">
        <button class="esf-button esf-button--standard esf-button--filled"
                (click)="setIsOpen(true)"
                [disabled]="selectedDataType === 'null'">
          <svg class="esf-icon esf-button__icon" width="16" height="16">
            <use xlink:href="#esf-icon-upload"></use>
          </svg>
          <span class="esf-button__icon-text" i18n="General submit button@@general.button.uploadImport">Upload import</span>
        </button>
      </div>
      <div class="esf-submit-row__item">
        <button class="esf-button esf-button--simple"
                (click)="downloadLink()"
                [disabled]="selectedDataType === 'null'">
          <svg class="esf-icon esf-button__icon" width="16" height="16">
            <use xlink:href="#esf-icon-download"></use>
          </svg>
          <span class="esf-button__icon-text" i18n="General back button@@general.button.downloadTemplate">Download template</span>
        </button>
      </div>
    </div>

  </div>
</main>

<app-upload-import [selectedClub]="selectedClub"
                   [isOpen]="isOpen"
                   [dataType]="selectedDataType"
                   (emitIsOpen)="setIsOpen($event)">
</app-upload-import>
